/**
 * Which campaign reads the list groups below (19/10/2026, user: "Tags of the
 * container's campaign" — a dynamic group's lists are its container's
 * campaign's, since performance tags are per campaign). A container editor
 * or a board row wraps its content once; every useListGroupResolve (and the
 * group editor's draft preview, useDraftRuleResolve) inside then asks for
 * that campaign's lists, with no new props on the call sites.
 * No provider = the country-wide read (the List Groups library).
 * For Media Devoted | Created By Ciro Autiero
 */
import { createContext, FC, ReactNode, useContext, useMemo } from 'react';

export interface ListGroupScopeValue {
  /** The reading container's SMSWiser campaign; null = country-wide. */
  campaignWiserId: number | null;
}

const ListGroupScopeContext = createContext<ListGroupScopeValue>({ campaignWiserId: null });

export const ListGroupScopeProvider: FC<{ campaignWiserId: number | null | undefined; children: ReactNode }> = ({
  campaignWiserId,
  children,
}) => {
  const value = useMemo(() => ({ campaignWiserId: campaignWiserId ?? null }), [campaignWiserId]);
  return <ListGroupScopeContext.Provider value={value}>{children}</ListGroupScopeContext.Provider>;
};

export const useListGroupScope = (): ListGroupScopeValue => useContext(ListGroupScopeContext);
